const objectToArray = (obj, keyName = 'id') => (!obj ? null : Object.keys(obj).map(key => ({ [keyName]: key, ...obj[key] })));

export default objectToArray;
